import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

import { WoltModal } from 'common/components';

import { ConfirmAndShare } from './ConfirmAndShare';
import { SelectMenu } from './SelectMenu';
import { useScopeContext } from '../../../contexts/ScopeContext';
import { useLiveSelectionData } from '../../../hooks/useLiveSelectionData';
import { useSharedMenuData } from '../../../hooks/useSharedMenuData';
import { VenueWithSharedMenuLinkInfo } from '../../../hooks/useVenuesWithSelectionLinks';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  selectedVenues: VenueWithSharedMenuLinkInfo[];
  search?: string;
  allVenuesSelected?: boolean;
};

const Root = styled(WoltModal)`
  width: 560px;
  border-radius: 8px;
  background-color: ${cbSemanticCssVars.surfaceMain};
  display: flex;
  flex-direction: column;
  overflow: visible;
`;

export const ShareMenuWithSelectedVenuesModal = ({
  isOpen,
  onClose,
  selectedVenues,
  allVenuesSelected,
  search,
}: Props) => {
  const scope = useScopeContext();
  const { sharedMenus, refetchSharedMenus } = useSharedMenuData({ scope });
  const [selectedMenuId, setSelectedMenuId] = useState<string | null>(null);

  const selectedMenu = useMemo(() => sharedMenus.find(m => m.id === selectedMenuId), [sharedMenus, selectedMenuId]);
  const { selectionData, selectionDataLoading, selectionDataError } = useLiveSelectionData({
    selectionId: selectedMenu?.id ?? null,
  });

  return (
    <Root isOpen={isOpen} onRequestClose={onClose}>
      {selectedMenu && selectionData ? (
        <ConfirmAndShare
          selectedVenues={selectedVenues}
          selectedMenu={selectedMenu}
          selectionData={selectionData}
          onBack={() => setSelectedMenuId(null)}
          onClose={onClose}
          refetchSharedMenus={refetchSharedMenus}
          search={search}
          allVenuesSelected={allVenuesSelected}
        />
      ) : (
        <SelectMenu
          sharedMenus={sharedMenus}
          isLoading={selectionDataLoading}
          error={selectionDataError}
          onContinue={setSelectedMenuId}
          onClose={onClose}
        />
      )}
    </Root>
  );
};
